import { useLazyGetNonceQuery, useLoginMutation } from "../../redux/auth.api";
import { useSignMessageMutation } from "../../redux/signer.api";
import { selectUser } from "../../redux/user.slice";
import { selectWallet } from "../../redux/wallet.slice";
import { useAppDispatch, useAppSelector } from "../hooks";
import "./home.page.sass";

interface IProps {}

const HomePage: React.FC<IProps> = () => {
  const dispatch = useAppDispatch();
  const { userToken } = useAppSelector(selectUser);
  const { address } = useAppSelector(selectWallet);
  const [getNonce] = useLazyGetNonceQuery();
  const [login] = useLoginMutation();
  const [signMessage] = useSignMessageMutation();
  return (
    <div className="home">
      {/* {userToken ? (
        <>
          <div>User is logged in</div>
          <button
            onClick={() => {
              dispatch(clearUser());
            }}
          >
            Logout
          </button>
        </>
      ) : (
        <button
          onClick={async () => {
            if (address) {
              const data = await getNonce(address).unwrap();
              const sign = await signMessage(`${address}.${data.nonce}`).unwrap();
              const token = await login({
                address,
                signature: sign,
              }).unwrap();
              dispatch(setUser(token));
            }
          }}
        >
          Login
        </button>
      )} */}
    </div>
  );
};

export default HomePage;
